import Cookies from 'js-cookie';
import { StateCreator } from 'zustand';
import * as wishlistSvc from '@/services/wishlist.service';
import { IWishlist } from '../types/IWishlist';
import INITIAL_STATE from '../initialState';

const createWishlistSlice: StateCreator<IWishlist> = (set, get) => ({
  wishlist: INITIAL_STATE.wishlist,
  updateWishlist(id) {
    set(state => ({ wishlist: { ...state.wishlist, items: state.wishlist.items.filter(i => i.id !== id) } }));
  },
  async deleteWishlistItem(wishlistId: number) {
    try {
      get().updateWishlist(wishlistId);
      await wishlistSvc.deleteWishlistItem(wishlistId);
      Cookies.set('wlCount', +Cookies.get('wlCount') - 1);
    } catch (e) {
      /* empty */
    }
  },
  async getWishlist() {
    try {
      const { data } = await wishlistSvc.getWishlist();
      set(() => ({ wishlist: data }));
    } catch (e) {
      /* empty */
    }
  },
  async moveWishlistItem(wishlistId) {
    try {
      get().updateWishlist(wishlistId);
      Cookies.set('wlCount', +Cookies.get('wlCount') - 1);
      Cookies.set('cartCount', +(Cookies.get('cartCount') || 0) + 1);

      return await wishlistSvc.moveWishlistItem(wishlistId);
    } catch (e) {
      /* empty */
    }
  },
});

export default createWishlistSlice;
